export { default as useUpdateUserViewResource } from "./useUpdateUserViewResource";
